"use client";

import { App, ConfigProvider } from "antd";
import { AntdRegistry } from "@ant-design/nextjs-registry";
import { brand } from "@/styles/brand";

export default function BrandThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    // `layer` makes antd emit its styles in @layer antd, so Tailwind utilities
    // (declared later in the globals.css layer order) can override antd defaults.
    <AntdRegistry layer>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: brand.primary,
            colorLink: brand.primary,
            colorLinkHover: brand.secondary,
            colorBgBase: brand.surface,
            colorTextBase: brand.textDark,
          },
          components: {
            Layout: {
              headerBg: brand.secondary,
            },
            Menu: {
              darkItemBg: brand.secondary,
              darkItemSelectedBg: brand.primary,
            },
            Segmented: {
              itemSelectedBg: brand.primary,
              itemSelectedColor: brand.surface,
            },
          },
        }}
      >
        <App>{children}</App>
      </ConfigProvider>
    </AntdRegistry>
  );
}
